import { Directive, HostListener } from "@angular/core";
import { NgControl } from "@angular/forms";

@Directive({ selector: "[yearSelector]" })
export class YearSelectorDirective {
    constructor(private ngControl: NgControl) {}

    @HostListener("blur", ["$event"]) onBlur() {
        if (new Date(this.ngControl.control.value).getFullYear() == 2001) {
            let date = new Date(this.ngControl.control.value);
            date.setFullYear(new Date().getFullYear());
            this.ngControl.control.setValue(date);
        }
    }
}
